module.exports = __webpack_public_path__ + "f4240bdc6ccf5e6440c4b6d629ed422d.svg";